import { MappedImage } from "src/utils/fw"

const bg = "https://assets.swoogo.com/uploads/full/3019375-651f05099a57a.png"
const vid = "https://player.vimeo.com/video/874902860?h=8b91fbe3be&amp;badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479&autoplay=1"
const button = "https://isflive.securityforum.org/isf-assure"

const links = [
    {
        top: "80%",
        left: "35.7%",
        width: "28.6%",
        height: "5.4%",
        label: "button",
        href: button,
        target: "_blank"
    }
]

export default () => {
    return <MappedImage roomName="ISF Assure Video" links={links} imageURL={bg}>
        <iframe src={vid} allowfullscreen style={{
            top: "27%",
            left: "21.7%",
            width: "56.3447%",
            height: "48.4%",
            position: "absolute",
            border: 0
        }} allow="autoplay" />
    </MappedImage>
}